const routes = [
    {
        path: "/course/outcome",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: ""
        }
    }
]

export default routes;
